import { computed, onMounted, ref, type ComputedRef } from 'vue';
import { getBrands } from '@/services/api';
import type { NativeSelectOption } from '@/components/widget/WidgetNativeSelect.vue';

const YEARS_BACK = 20;

export function buildYearRange(nextYearAvailable: boolean, currentYear: number): number[] {
  const maxYear = nextYearAvailable ? currentYear + 1 : currentYear;
  const years: number[] = [];
  for (let year = maxYear; year >= currentYear - YEARS_BACK; year--) {
    years.push(year);
  }
  return years;
}

/** Year choices; next year is offered only when the catalog already has brands for it. */
export function useVehicleYears(): { yearOptions: ComputedRef<NativeSelectOption[]> } {
  const isNextYearAvailable = ref(false);

  onMounted(async () => {
    const nextYear = new Date().getFullYear() + 1;
    try {
      const brands = await getBrands(nextYear);
      isNextYearAvailable.value = Boolean(brands && brands.length > 0);
    } catch {
      isNextYearAvailable.value = false;
    }
  });

  const yearOptions = computed(() =>
    buildYearRange(isNextYearAvailable.value, new Date().getFullYear()).map((year) => ({
      value: year,
      label: String(year),
    })),
  );

  return { yearOptions };
}
